import DataGrid, { Column } from 'devextreme-react/data-grid'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import api from '../../../../../services/api-configuration'
// import { FaCircle } from "react-icons/fa";

function IslemlerSilmePopup({ isOpen, toggle, chassis, groupage, refreshData, onGroupageEmpty }) {
    const selectedVehicleData = chassis ? [chassis] : [];
    const [buttonStatus, setButtonStatus] = useState("idle");
    const [addressMessage, setAddressMessage] = useState("");
    const [isGroupageEmpty, setIsGroupageEmpty] = useState(false);


    const handleClose = async () => {
        if (buttonStatus === "loading") return;

        // Eğer işlem yapıldıysa (address message varsa) refresh data çağır
        if (addressMessage) {
            const result = await refreshData();
            // Eğer grupajda şase kalmadıysa işlemler popup'ını da kapat
            if (isGroupageEmpty && onGroupageEmpty) {
                // refreshData zaten toast mesajı attı ve işlemler popup'ını kapattı
                // Bu durumda sadece mevcut modal'ı kapat
            } else if (result && result.isEmpty && onGroupageEmpty) {
                // refreshData'da "no rows in result set" hatası geldi
                onGroupageEmpty();
            }
        }

        toggle();
        setButtonStatus("idle");
        setAddressMessage("");
        setIsGroupageEmpty(false);
    };

    const handleRemoveConfirm = async () => {
        setButtonStatus("loading")
        try {
            //ilker endpoint tanımalyınca düzenlenecek 
            const response = await api.post('/removeVehicleFromTheGroupage', {
                chassis_no: chassis.chassis_no,
                groupage_no: groupage.groupage_no,
                type: "success"
            })
            const successMessage = document.getElementById("success");
            toast.success(response.data.message)

            // Address bilgisini set et
            if (response.data.address) {
                setAddressMessage(response.data.address)
                successMessage.style.display = "block"
                setButtonStatus("success")

                // Eğer grupajda şase kalmadıysa state'i güncelle
                if (response.data.remaining_chassis_count === 0 || response.data.is_groupage_empty) {
                    setIsGroupageEmpty(true)
                }
                // Address varsa modal açık kalır, kullanıcı kendisi kapatır
            } else {
                // Address yoksa otomatik kapat
                setButtonStatus("success")

                // Eğer grupajda şase kalmadıysa işlemler popup'ını da kapat
                if (response.data.remaining_chassis_count === 0 || response.data.is_groupage_empty) {
                    toast.info("Grupajda başka şase kalmamıştır. İşlemler ekranı kapatılıyor.")
                    setTimeout(() => {
                        toggle();
                        setButtonStatus("idle");
                        if (onGroupageEmpty) {
                            onGroupageEmpty();
                        }
                    }, 1000)
                } else {
                    // Grupajda başka şase var, sadece bu modal'ı kapat ve refresh yap
                    refreshData();
                    setTimeout(() => {
                        toggle();
                        setButtonStatus("idle");
                    }, 1000)
                }
            }
        } catch (error) {
            console.error(error)
            let message = error.response?.data?.error || "Bir Hata Oluştu"

            // Eğer "already removed from groupage" hatası varsa
            if (message.toLowerCase().includes("grupajdan çıkarılmıltır")) {
                toast.warning(message)

                // Silme modalını kapat
                setTimeout(() => {
                    toggle();
                    setButtonStatus("idle");

                    // Eğer silinmeye çalışılan şase dışında başka şase yoksa işlemler modalını da kapat
                    // Grupajda sadece 1 şase varsa (silinmeye çalışılan şase) işlemler modalını kapat
                    if (groupage?.chassis_details?.length === 1 && onGroupageEmpty) {
                        toast.info("Grupajda başka şase kalmamıştır. İşlemler ekranı kapatılıyor.")
                        onGroupageEmpty();
                    } else {
                        // Başka şaseler varsa refresh yap
                        refreshData();
                    }
                }, 1000)
            } else {
                toast.error(message)
                setButtonStatus("idle")
            }
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            backdrop="static"
            keyboard={false}
            className="modal-dialog modal-lg"
            style={{
                height: "345px",
                maxHeight: "400px",
                maxWidth: "700px",
                width: "90%",
                margin: "1.75rem auto"
            }}
        >
            <ModalHeader toggle={handleClose}>
                Grupaj Çıkartma Onayı
            </ModalHeader>
            <ModalBody >
                <Row>
                    <Col>
                        <p style={{ textAlign: "center", fontSize: "20px" }}>Aşağıdaki aracı grupajdan çıkartmak istediğinize emin misiniz?</p>
                        <DataGrid
                            dataSource={selectedVehicleData}
                            showBorders={true}
                            showRowLines={true}
                            showColumnLines={true}
                            width="100%"
                        >
                            <Column dataField="groupage_no" caption="Grupaj No" alignment="center" />
                            <Column dataField="chassis_no" caption="Şase No" alignment="center" />
                            <Column caption='Model Adı' dataField='model' alignment='center' />
                            <Column caption='Renk Adı' dataField='color' alignment='center' />
                        </DataGrid>
                        {/* eğer işlem success ise aracın yeni adresini bastırmalıyım dikkat çekici bir yapı olsun */}
                        <hr />
                        <p
                            id='success'
                            style={{
                                display: "none",
                                textAlign: "center",
                                color: "#04ac04",
                                fontSize: "17px",
                                fontWeight: "bold",
                                width: "max-content",
                                margin: "20px auto"
                            }}
                        > ✓ İşlem Başarıyla Tamamlandı.
                            <p
                                style={{
                                    color: "#424242", fontSize: "15px",
                                    display: "flex",
                                    justifyContent: "left",
                                    alignItems: "center"
                                }}>

                                {/* <FaCircle style={{ verticalAlign: "middle", fontSize: "11px", color: "#04ac04" }} /> */}
                                <div style={{
                                    width: '8px',
                                    height: '8px',
                                    backgroundColor: '#28a745',
                                    borderRadius: '50%',
                                    marginRight: '12px',



                                }}></div>
                                Aracın Güncel Adresi : <strong style={{ background: "rgb(255 237 237)", color: "red", padding: "3px" }}> {addressMessage} </strong>
                            </p>


                        </p>
                    </Col>

                </Row>

            </ModalBody>
            <ModalFooter>

                <Button color="danger"
                    disabled={buttonStatus === "loading" || buttonStatus === "success"}
                    onClick={handleRemoveConfirm}>
                    {{
                        idle: "Çıkart",
                        loading: "Çıkartılıyor...",
                        success: "Çıkartıldı"
                    }[buttonStatus]}
                </Button>
            </ModalFooter>
        </Modal>
    )
}


export default IslemlerSilmePopup